import React from 'react'
import ReactDOM from 'react-dom'
import App from './app'

import './style/normalize.css'
import './style/global.css'
import { setSentry } from 'app/utils/sentry'
import SentryErrorBoundary from 'app/components/SentryErrorBoundary'

window.APP_VERSION = process.env.APP_VERSION
window.GIT_COMMIT_SHA = process.env.GIT_COMMIT_SHA

setSentry({
  dsn: process.env.REACT_APP_MOZIO_PUBLIC_SENTRY_DSN,
  environment: process.env.CONFIG_ENV,
  release: process.env.APP_VERSION,
  projectId: process.env.REACT_APP_MOZIO_PUBLIC_SENTRY_PROJECT_ID,
  organization: process.env.REACT_APP_MOZIO_PUBLIC_SENTRY_ORGANIZATION,
})

ReactDOM.render(
  <SentryErrorBoundary>
    <App />
  </SentryErrorBoundary>,
  document.getElementById('root')
)
